// Author Liang Gangqiang
// Date 2022-08-18 16:13:57

import * as model from "@/model/em/archive/EmArchScrapProcessAspModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmArchScrapProcessAsp(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        callbackApi: process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchScrapProcessAsp/workflow/complete-feedback',
        processDefinitionKey: "em_archive_scrap",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
